import { FlatList, StyleSheet, View } from 'react-native';

import Text from './Text';

interface NumeratedBulletListProps {
  list: string[];
}

const NumeratedBulletList = ({ list }: NumeratedBulletListProps) => {
  return (
    <FlatList
      data={list}
      keyExtractor={(_, index) => index.toString()}
      scrollEnabled={false}
      renderItem={({ item, index }) => (
        <View key={index} style={styles.bulletList}>
          <Text fontWeight="700" style={styles.bulletListNumber}>
            {index + 1}.
          </Text>
          <Text style={styles.bulletListText}>{item}</Text>
        </View>
      )}
    />
  );
};

const styles = StyleSheet.create({
  bulletList: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginBottom: 5
  },

  bulletListText: {
    fontSize: 14
  },

  bulletListNumber: {
    fontSize: 14,
    marginRight: 5,
    width: 20,
    textAlign: 'left'
  }
});

export default NumeratedBulletList;
